import Dashboard from '@domains/dashboard/views/Dashboard.vue'

export default [
  {
    path: 'dashboard',
    component: Dashboard,
    name: 'Dashboard'
  }
]
